import api from './api'
import { Pet, CreatePetDto, UpdatePetDto } from '../types/Pet'

export const petService = {
  async getPets(): Promise<Pet[]> {
    const response = await api.get<Pet[]>('/api/pets')
    return response.data
  },

  async getPet(id: string): Promise<Pet> {
    const response = await api.get<Pet>(`/api/pets/${id}`)
    return response.data
  },

  async createPet(pet: CreatePetDto): Promise<Pet> {
    const response = await api.post<Pet>('/api/pets', pet)
    return response.data
  },

  async updatePet(id: string, pet: UpdatePetDto): Promise<Pet> {
    const response = await api.put<Pet>(`/api/pets/${id}`, pet)
    return response.data
  },

  async deletePet(id: string): Promise<void> {
    await api.delete(`/api/pets/${id}`)
  },

  async associateTag(petId: string, tagCode: string): Promise<Pet> {
    const response = await api.post<Pet>(`/api/pets/${petId}/tag`, { tagCode })
    return response.data
  },

  async setLostStatus(petId: string, isLost: boolean, location?: string): Promise<Pet> {
    const response = await api.patch<Pet>(`/api/pets/${petId}/lost-status`, {
      isLost,
      lostSince: isLost ? new Date().toISOString() : null,
      lastKnownLocation: location
    })
    return response.data
  },

  async uploadPhoto(petId: string, file: File): Promise<Pet> {
    const formData = new FormData()
    formData.append('file', file)
    const response = await api.post<Pet>(`/api/pets/${petId}/photo`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return response.data
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async getScanReports(petId: string): Promise<any[]> {
    const response = await api.get(`/api/pets/${petId}/scan-reports`)
    return response.data
  },

  async getNotificationPreferences(): Promise<{ tagScanned: boolean; lostMode: boolean; tagRegistered: boolean }> {
    const response = await api.get('/api/notifications/preferences')
    return response.data
  },

  async updateNotificationPreferences(prefs: { tagScanned: boolean; lostMode: boolean; tagRegistered: boolean }): Promise<void> {
    await api.put('/api/notifications/preferences', prefs)
  }
}
